import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Nullable } from 'global';
import makeStyles from '@mui/styles/makeStyles';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  canWrite: boolean;
  productLogoUrl: Nullable<string>;
  productLogoPreview: Nullable<string>;
  setProductLogo: Dispatch<SetStateAction<Nullable<File>>>;
  setProductLogoPreview: Dispatch<SetStateAction<Nullable<string>>>;
  handleProductLogoChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const LogoSection = ({
  canWrite,
  productLogoUrl,
  setProductLogo,
  productLogoPreview,
  setProductLogoPreview,
  handleProductLogoChange,
}: Props) => {
  const classes = useStyles();

  return (
    <>
      <Box>
        <Button variant="contained" component="label" disabled={!canWrite}>
          Set Logo
          <input type="file" accept="image/*" hidden onChange={handleProductLogoChange} />
        </Button>
      </Box>

      <RenderWithCondition condition={!!productLogoUrl}>
        <Stack>
          <Typography>Current Icon</Typography>

          <Box>
            <img src={productLogoUrl!} alt="Current Product Logo" className={classes.img} />
          </Box>
        </Stack>
      </RenderWithCondition>

      <RenderWithCondition condition={!!productLogoPreview}>
        <Stack gap="0.5rem">
          <Stack direction="row" alignItems="center">
            <IconButton color="primary" size="small">
              <DeleteOutlineIcon
                color="error"
                onClick={() => {
                  setProductLogo(null);
                  setProductLogoPreview(null);
                }}
              />
            </IconButton>

            <Typography>New Icon</Typography>
          </Stack>

          <Box>
            <img src={productLogoPreview!} alt="Selected product logo" className={classes.img} />
          </Box>
        </Stack>
      </RenderWithCondition>
    </>
  );
};

const useStyles = makeStyles({
  img: {
    width: 'auto',
    maxHeight: 64,
    borderRadius: 4,
    border: '1px solid #ccc',
  },
});
